import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import {ClientContactService} from "../../../service/ClientContactService";
import ClientContact from "../../../entities/ClientContact";

class ContactDetailsStore {

    public clientId: string;
    public contactId: string;
    public contact: ClientContact;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, clientId: string, contactId: string) {
        this.clientId = clientId;
        this.contactId = contactId;
        this.isModalOpen = false;
        this.contact = {} as ClientContact;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async loadContact() {
        this.loading = true;
        const response = await ClientContactService.find(this.clientId, this.contactId)
        if (response.success && response.data) {
            this.contact = response.data;
            this.loading = false;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
        this.contact = {} as ClientContact;
    }

}

export default ContactDetailsStore;